// extracted by mini-css-extract-plugin
export default {"container":"styles_container__rNW87","content":"styles_content__8pOsP"};